import { Outlet } from 'react-router-dom'

export default function GuestRoot() {
  return <Outlet />
}
